import BellIcon from 'assets/icons/bell.svg';
import SettingsIcon from 'assets/icons/settings.svg';
import cn from 'classnames/bind';
import Link from 'next/link';
import { Button, Badge } from 'ui';
import SupportLink from 'ui/components/brainable/SupportLink';
import DrawerUserInfo from 'ui/layouts/MobileNavigation/DrawerUserInfo';
import MobileNavigationItems from 'ui/layouts/MobileNavigation/MobileNavigationItems';
import SearchPageForm from 'ui/layouts/SearchPageForm';

import s from './MobileNavigationPrimary.module.scss';

const cx = cn.bind(s);

const PrimaryMenu = ({
  short = false,
  user,
  openNotifications,
  notificationsCount,
  className,
  logoutComponent,
  items = [],
  hasAuthAction = true,
  onClose,
  ...attrs
}) => {
  if (short) {
    return <SupportLink />;
  }
  return (
    <div className={cx(className)} {...attrs}>
      {user && <DrawerUserInfo user={user} className={cx('userInfo')} />}
      <div className={cx('drawerMainContent')}>
        <SearchPageForm
          className={cx('searchBox')}
          iconSize="large"
          onSubmit={onClose}
        />
        {user && (
          <div className={cx('tools')}>
            <div
              className={cx('tool')}
              role="button"
              tabIndex="0"
              onClick={openNotifications}
            >
              <Badge size="small" count={notificationsCount}>
                <div className={cx('toolLink')}>
                  <BellIcon />
                </div>
              </Badge>
            </div>
            <div className={cx('tool')}>
              <Link href="/profile/settings" className={cx('toolLink')}>
                <SettingsIcon />
              </Link>
            </div>
          </div>
        )}
        <MobileNavigationItems
          items={items}
        />
        {hasAuthAction && (
          <div className={cx('authButtonContainer')}>
            {user ? (
              logoutComponent
            ) : (
              <Link href="/login" className={cx('authButton')}>
                Log in
              </Link>
            )}
          </div>
        )}
        {!user && (
          <div className={cx('testButtonContainer')}>
            <Button href={'/free-personality-test'} as="a">
              Take the test
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrimaryMenu;
